import type { UnDef } from '@jhqn/utils'
import { initRegion } from '@/consts'
import { setCryptoKey } from '@jhqn/utils'

setCryptoKey(import.meta.env.VITE_CRYPTO_KEY)

/** JwtToken */
export const jwtTokenAtom = atomWithLocal<UnDef<string>>('jwtToken', null, true)

/** 登录用户信息 */
export const userInfoAtom = atom<UnDef<Login.UserInfoVO>>(null)

/**
 * 当前用户所在区域
 * @description 默认 330700 金华
 */
export const regionAtom = atomWithLocal<Global.OptionItem[]>('region', initRegion, true)

/**
 * 功能开关
 */
export const switchAtom = atomWithSession<Contact.ContentSwitchVO>('switch', {}, true)

export const clearStorageAtom = atom(null, (get, set) => {
  set(jwtTokenAtom, null)
  set(userInfoAtom, null)
  set(regionAtom, initRegion)
})

export const die = () => window.dispatchEvent(new Event('die'))
